export default {
  import: {
    enabled: "Import system enabled",
    defaultAuthMode: "Default Auth mode",
    logPayloads: "Log payloads (debug)",
    authMode: {
      session: "Session",
      apiKey: "API key",
      none: "None"
    },
    rateLimit: {
      windowSeconds: "Rate limit window (seconds)",
      max: "Max requests per window"
    },
    endpoints: {
      pull: {
        enabled: "Pull endpoint enabled",
        authMode: "Auth mode"
      }
    }
  }
}
